import { LDFlags } from '../constants/flags';
import { loadRudderStack } from '../services/analytics/rudderstack';
import { logger } from '../services/sentry';
import { isOptedOutForSession, isTrackingDenied } from '../utils/privacy';
import useFlag from './useFlag';
import useOnce from './useOnce';

const useLoadRudderStack = () => {
  const isConsentEnabled = useFlag(LDFlags.COM_PRIVACY_RUDDER_CONSENT);

  useOnce(() => {
    if (!isConsentEnabled) {
      loadRudderStack();
      return;
    }

    isTrackingDenied()
      .catch((error) => {
        logger.error(
          'useLoadRudderStack.ts',
          'Consent check failed, loading as allowed',
          {},
          error,
        );
        return false;
      })
      // A lookup opt-out can land while the region resolves
      .then((isDenied) => loadRudderStack({ isDenied: isDenied || isOptedOutForSession() }));
  });
};

export default useLoadRudderStack;
